module.exports = __webpack_public_path__ + "img/setting.033d00ac.png";